import React, { useState } from "react";
import Slider from "react-slick";
import dubaiBg1 from "../../assets/hero2.jpeg";
import dubaiBg2 from "../../assets/hero1.jpeg";
import dubaiBg3 from "../../assets/hero3.jpeg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/HeroSection.css";
import SearchBar from "../SearchBar/SearchBar";

const HeroSection = () => {
  // State to manage input values
  const [city, setCity] = useState("");
  const [complete, setComplete] = useState("");
  const [price, setPrice] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [searchResult, setSearchResult] = useState(null);

  const [toggle, setToggle] = useState(false);
  const handleClick = () => setToggle(!toggle);
  const handleSelect = (value) => {
    setCity(value);
    setToggle(false);
  };

  const options = [
    "Al Barari",
    "Al Barsha",
    "Al Furjan",
    "Al Habtoor City",
    "Al Hamra Village",
    "Al Jaddaff",
    "Al Jurf",
    "Al Kifaf",
    "Al Marjan Island",
    "Al Reem Island",
    "Al Safa",
    "Al Sufouh",
    "Al Wasl",
    "Al Zorah",
    "Arabian Ranches",
    "Arabian Ranches 2",
    "Arabian Ranches 3",
    "Arjan",
    "Bluewaters Island",
    "Burj Khalifa District",
    "Business Bay",
    "City Walk",
    "Culture Village",
    "DIFC",
    "Deira",
    "Downtown Dubai",
    "Downtown Jebel Ali",
    "Dubai Canal",
    "Dubai Creek Harbour",
    "Dubai Festival City",
    "Dubai Healthcare City",
    "Dubai Hills Estate",
    "Dubai Investment Park",
    "Dubai Islands",
    "Dubai Marina",
    "Dubai Production City",
    "Silicon Oasis",
    "Dubai South",
    "Dubai Sports City",
    "Dubailand",
    "Emaar Beachfront",
    "Emaar South",
    "Emirates Hills",
    "Emirates Living",
    "Expo City Dubai",
    "Falconcity",
    "Hudayriyat Island",
    "International City",
    "JBR",
    "Jebel Ali",
    "Jebel Ali Village",
    "Jumeira Bay",
    "Jumeirah",
    "Jumeirah Golf Estate",
    "Jumeirah Height",
    "Jumeirah Islands",
    "Jumeirah Lake Towers",
    "Jumeirah Park",
    "Jumeirah Village Circle",
    "Jumeirah Village Triangle",
    "MBR City",
    "Madinat Badr",
    "Madinat Jumeirah Living",
    "Majan",
    "Marine Drive",
    "Meadows",
    "Meydan City",
    "Mirdif Hills",
    "Motor City",
    "Mudon",
    "Muscat Bay",
    "Nad Al Hammar",
    "Nad Al Sheba",
    "Palm Jebel Ali",
    "Palm Jumeirah",
    "Pearl Jumeirah",
    "Port De La Mer",
    "Remraam",
    "Sheikh Zayed Road",
    "Sobha Hartland",
    "Springs",
    "Studio City",
    "The Lakes",
    "The Opera District",
    "The Valley",
    "The Views",
    "Tilal Al Ghaf",
    "Town Square",
    "Umm Suqeim",
    "Villanova",
    "Yas Bay",
    "Zaabeel",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
  };

  // Function to handle search button click
  const handleSearch = () => {
    // Dummy logic to simulate search
    const result = {
      city: city || "Dubai",
      price: price || "Any",
      propertyType: propertyType || "Any",
    };
    setSearchResult(result);
  };

  return (
    <section
      className="relative h-[70vh] md:h-[90vh] *:font-sans flex flex-col justify-center items-center"
      style={{
        overflow: "hidden",
      }}
    >
      <Slider
        {...settings}
        className="absolute top-0 left-0 w-full h-[70vh] md:h-screen z-10"
      >
        {/* Slide 1 */}
        <div className="relative w-full h-[70vh] md:h-screen">
          <div className="absolute top-0 left-0 w-full h-[70vh] md:h-screen">
            <div className="absolute inset-0 bg-black opacity-40"></div>
            <img
              src={dubaiBg1}
              alt="Background"
              className="absolute top-0 left-0 w-full h-[70vh] md:h-screen"
            />
          </div>
        </div>

        {/* Slide 2 */}
        <div className="relative w-full h-[70vh] md:h-screen">
          <div className="absolute top-0 left-0 w-full h-[70vh] md:h-screen">
            <div className="absolute inset-0 bg-black opacity-40"></div>
            <img
              src={dubaiBg2}
              alt="Background"
              className="absolute top-0 left-0 w-full h-[70vh] md:h-screen"
            />
          </div>
        </div>

        {/* Slide 3 */}
        <div className="relative w-full h-[70vh] md:h-screen">
          <div className="absolute top-0 left-0 w-full h-[70vh] md:h-screen">
            <div className="absolute inset-0 bg-black opacity-40"></div>
            <img
              src={dubaiBg3}
              alt="Background"
              className="absolute top-0 left-0 w-full h-[70vh] md:h-screen"
            />
          </div>
        </div>
      </Slider>

      {/* Centered SearchBar */}
      <div className="absolute flex items-center justify-center w-full ">
        <SearchBar
          searchResult={searchResult}
          setSearchResult={setSearchResult}
          options={options}
          isInternalPage={false}
        />
      </div>
    </section>
  );
};

export default HeroSection;
